import PropTypes from 'prop-types'

import { isAuthenticated, isAuthorizedRole } from "./AppSecurity";

export const RenderAuthenticated = ({ children }) =>
    (isAuthenticated()) ? children : null
;

export const RenderAnonymous = ({ children }) => 
    (isAuthenticated()) ? null : children;

export const RenderByRole = ({ roles, children }) =>
    (isAuthorizedRole(roles) ? children : null)
;

RenderByRole.propTypes = {
    roles: PropTypes.arrayOf(PropTypes.string).isRequired,
}
